export default "__VITE_PUBLIC_ASSET__3a6ad440__"